import React from 'react';
import { useTranslator } from '@jutro/locale';
import { FlexUtil } from 'wmic-pe-capability-gateway-common-react';
import PropTypes from 'prop-types';
import messages from './WMICFlexValidationErrorMessage.messages';
import styles from './WMICFlexValidationErrorMessage.module.scss';
import { Icon } from '@jutro/legacy/components';

function WMICFlexValidationErrorMessage({ jobVM }) {
    const translator = useTranslator();
    const hasFlexErrors = FlexUtil.hasInvalidFlexFields(jobVM);

    if (!hasFlexErrors) {
        return null;
    }

    return (
        <div className={`${styles.wmicValidationErrorContainer} noPrint`}>
            <div className={styles.wmicValidationErrorType}>
                <div className={styles.wmicValidationErrorMessageContainer}>
                    <Icon className={styles.wmicValidationErrorIcon} icon="mi-warning" />
                    <p>{translator(messages.flexValidationErrorMessage)}</p>
                </div>
            </div>
        </div>
    );
}

WMICFlexValidationErrorMessage.propTypes = {
    jobVM: PropTypes.shape({}).isRequired,
};

export default WMICFlexValidationErrorMessage;
